<template>
    <fragment>
        <c-generic-section>
            <div class="container-sm center-content">
                <h1 class="mt-0 ct-title">Contact Us</h1>
                <p class="mb-0">Talk to us in English or Chinese &mdash; by WeChat, WhatsApp or email, whichever suits you.</p>
                <p class="ct-zh">联系我们 &mdash; 微信、WhatsApp、邮件均可,提供中英双语服务。</p>

                <div class="ct-cards ct-methods">
                    <div class="ct-card">
                        <h4 class="ct-card-title">
                            <img
                                class="ct-icon"
                                width="28"
                                height="28"
                                :src="require('@/assets/images/wechat.png')"
                                alt="WeChat icon" />
                            <span>WeChat 微信</span>
                        </h4>
                        <p class="ct-number text-color-high">+8613986837403</p>
                        <p class="m-0">Admin account &mdash; scan the QR code or add the number above.</p>
                        <p class="ct-zh">管理员微信,扫码或输入号码添加。</p>
                        <img
                            class="ct-qr"
                            width="150"
                            height="150"
                            :src="require('@/assets/images/QRCode.png')"
                            alt="WeCom QR code for the Line-1 admin account" />
                    </div>
                    <div class="ct-card">
                        <h4 class="ct-card-title">
                            <img
                                class="ct-icon"
                                width="28"
                                height="28"
                                :src="require('@/assets/images/whatsapp.png')"
                                alt="WhatsApp icon" />
                            <span>WhatsApp</span>
                        </h4>
                        <p class="ct-number text-color-high">
                            <a href="https://wa.me/61426188363" target="_blank" rel="noopener">+61426188363</a>
                        </p>
                        <p class="m-0">Importation enquiries.</p>
                        <p class="ct-zh">进口业务咨询请加 WhatsApp。</p>
                    </div>
                    <div class="ct-card">
                        <h4 class="ct-card-title">
                            <span>Email</span>
                        </h4>
                        <p class="ct-number text-color-high">
                            <a href="mailto:enquiry@line-1.com.au">enquiry@line-1.com.au</a>
                        </p>
                        <p class="m-0">Quotes and general enquiries.</p>
                        <p class="ct-zh">报价与一般咨询请发送邮件。</p>
                    </div>
                </div>
            </div>
        </c-generic-section>

        <c-generic-section top-divider>
            <div class="container-sm">
                <c-section-header :data="warehouseHeader" class="center-content" />
                <div class="ct-warehouse">
                    <div class="ct-card">
                        <h4 class="mt-0 mb-8">Line-1 Logistics Pty Ltd</h4>
                        <p class="mb-8"><b>Address:</b> Unit 2, 11 Ferguson St, Kewdale WA 6105</p>
                        <p class="mb-8"><b>Email:</b> <a href="mailto:enquiry@line-1.com.au">enquiry@line-1.com.au</a></p>
                        <p class="mb-8"><b>Admin WeChat:</b> +8613986837403</p>
                        <p class="mb-8"><b>Hours:</b> Mon&ndash;Fri 10AM&ndash;4PM; weekends and public holidays if necessary</p>
                        <p class="mb-0 text-sm text-color-low">The Kewdale warehouse is not open for retail &mdash; retail business is handled in-store at our shops below.</p>
                        <p class="ct-zh">Kewdale 仓库不对外营业,零售业务请前往门店办理。</p>
                    </div>
                    <div class="ct-map">
                        <iframe
                            title="Map of the Line-1 Logistics warehouse at Unit 2, 11 Ferguson St, Kewdale WA 6105"
                            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJnQbOqfS9MioR4zywt5ERACI&key=AIzaSyA81B2T5xZbmk1hYQyKj4rTIBJLiVlIhIk"
                            allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </c-generic-section>

        <c-generic-section top-divider>
            <div class="container-sm">
                <c-section-header :data="storesHeader" class="center-content" />
                <div class="ct-cards ct-stores">
                    <div class="ct-card">
                        <h4 class="mt-0 mb-4">Line-1 北桥店</h4>
                        <p class="mb-8">Suite 3, 1 Forbes Road, Perth WA 6000</p>
                        <p class="m-0 text-sm text-color-low">Open daily 每天营业</p>
                    </div>
                    <div class="ct-card">
                        <h4 class="mt-0 mb-4">Line-1 Cannington直营店</h4>
                        <p class="mb-8">Unit 3, 1341 Albany Highway, Cannington WA 6107</p>
                        <p class="m-0 text-sm text-color-low">Open daily 每天营业</p>
                    </div>
                </div>
            </div>
        </c-generic-section>
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import section header
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
// import sections
import CGenericSection from '@/components/sections/GenericSection.vue'

export default {
  name: 'Contact',
  components: {
    CSectionHeader,
    CGenericSection
  },
  data() {
    return {
      warehouseHeader: {
        title: 'Warehouse & Office',
        paragraph: 'Our own 2,200 m² warehouse in Kewdale, Perth'
      },
      storesHeader: {
        title: 'Our Stores 直营门店',
        paragraph: 'Retail business is handled in-store — visit us at either location.'
      }
    }
  },
  created() {
    document.title = 'Contact Us | Line-1 Logistics'
    this.$emit('update:layout', CLayout)
  }
}
</script>

<style scoped>
.ct-title {
    margin-bottom: 12px;
}
.ct-zh {
    font-size: 13px;
    opacity: .7;
    margin-top: 6px;
    margin-bottom: 0;
}
.ct-cards {
    display: grid;
    gap: 24px;
    text-align: left;
}
.ct-methods {
    grid-template-columns: repeat(3, 1fr);
    margin-top: 32px;
}
.ct-stores {
    grid-template-columns: 1fr 1fr;
}
.ct-card {
    border: 1px solid rgba(128, 128, 128, .3);
    border-radius: 6px;
    padding: 20px 24px;
}
.ct-card-title {
    display: flex;
    align-items: center;
    margin-top: 0;
    margin-bottom: 12px;
    min-height: 28px;
}
.ct-icon {
    flex-shrink: 0;
    margin-right: 10px;
}
.ct-number {
    font-weight: 600;
    margin-bottom: 8px;
    word-break: break-all;
}
.ct-qr {
    display: block;
    margin-top: 16px;
    border: 1px solid rgba(128, 128, 128, .3);
    border-radius: 6px;
}
.ct-warehouse {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 24px;
    align-items: start;
    text-align: left;
}
.ct-map {
    position: relative;
    width: 100%;
    padding-bottom: 66%;
    border: 1px solid rgba(128, 128, 128, .3);
    border-radius: 6px;
    overflow: hidden;
}
.ct-map iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
@media (max-width: 840px) {
    .ct-methods {
        grid-template-columns: 1fr;
    }
    .ct-warehouse {
        grid-template-columns: 1fr;
    }
    .ct-map {
        padding-bottom: 75%;
    }
}
@media (max-width: 640px) {
    .ct-stores {
        grid-template-columns: 1fr;
    }
}
</style>
